var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"content-container relative"},[(!_vm.hideBack)?_c('BackButton'):_vm._e(),_c('b-container',[_c('div',{staticClass:"d-flex justify-content-between border-bottom pb-2 mb-2"},[_c('h4',{staticClass:"text-left my-auto"},[_vm._t("title")],2),_vm._t("header")],2),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }